
import Countdown from 'vux/src/components/countdown/index.vue'

import { mapState, mapActions } from 'vuex'
import qrcode from '@/components/qrcode.vue'

export default {
components: {
Countdown,
qrcode
},
data () {
return {
formValidated: false,
loginModel: 'verifyCode',
mobile: '',
password: '',
vcode: '',
verifyCode: '',
isMobileValidated: false,
timer: 60,
timerStart: false,
error: false,
message: ''
}
},
beforeRouteEnter (to, from, next) {
next(vm => {
if (localStorage.loginModel) {
vm.loginModel = localStorage.loginModel
}
})
},
methods: {
...mapActions([
'setUser'
]),
validatedForm () {
this.isMobileValidated = this.$refs.inpLoginMobile.valid
this.formValidated = this.isMobileValidated &&
((this.loginModel !== 'verifyCode' &&
this.password.length &&
(this.vcode.length || this.error === false)) ||
(this.loginModel === 'verifyCode' &&
this.verifyCode.length))
},
changeLoginModel () {
if (this.loginModel === 'verifyCode') {
this.loginModel = 'password'
} else {
this.loginModel = 'verifyCode'
}
localStorage.loginModel = this.loginModel
},
mobileError () {
this.$vux.toast.show({
text: this.mobile.length ? '手机号码无效' : '请输入手机号'
})
},
passwordError () {
this.$vux.toast.show({
text: '请输入密码'
})
},
vcodeError () {
this.$vux.toast.show({
text: '请输入验证码'
})
},
verifyCodeError () {
this.$vux.toast.show({
text: '请输入验证码'
})
},
reloadVCodeImg () {
document.getElementById('imgVCode').src = '/api/verify?' + (new Date()).valueOf()
},
sendVerifyCode () {
this.message = ''
this.timerStart = true
this.$sendVerifyCode(this.mobile.replace(/\s+/g, ''), (res) => {
if (!res.success) {
this.timerStart = false
this.$vux.toast.show({
text: res.message,
width: '16em'
})
}
})
},
timerFinish () {
this.timerStart = false
},
login () {
this.validatedForm()
if (!this.formValidated) {
return
}
this.message = ''
this.$vux.loading.show()
let mobile = this.mobile.replace(/\s+/g, '')
let pwd = ''
let vcode = ''
let verifyCode = ''
if (this.loginModel === 'verifyCode') {
verifyCode = this.verifyCode
} else {
pwd = this.password
vcode = this.vcode
}
this.$login(mobile, pwd, vcode, verifyCode, (res) => {
this.$vux.loading.hide()
if (res.success) {
this.error = false
if (res.data) {
this.setUser(res.data)
}
if (this.$route.query && this.$route.query.redirect) {
this.$router.replace({path: this.$route.query.redirect})
} else {
this.$router.push({name: 'My'})
}
} else {
this.password = ''
this.verifyCode = ''
if (this.vcode.length) {
this.reloadVCodeImg()
this.vcode = ''
}
this.error = true
this.message = res.message
}
})
},
wechat () {
if (this.$isWechat()) {
if (this.$route.query && this.$route.query.redirect) {
window.location.href = '/api/wechat/login?redirect=' + encodeURI(this.$route.query.redirect)
} else {
window.location.href = '/api/wechat/login'
}
} else {

}
}
},
computed: {
...mapState({
user: state => state.oice.user
})
}
}



// WEBPACK FOOTER //
// ./src/pages/index/views/Login.vue